import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'itemBudget': [],
  'loading': false,
  'saving': false,
};

export const itemBudget = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ITEM_BUDGET]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ITEM_BUDGET]: (state, action) => ({
      ...state,
      'loading': false,
      'itemBudget': action.response.data,
    }),
    [ActionTypes.FETCHED_ITEM_BUDGET_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'itemBudget': [],
    }),
    [ActionTypes.ADDING_ITEM_BUDGET]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.ADDED_ITEM_BUDGET]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.ADDED_ITEM_BUDGET_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.DELETE_ITEM_BUDGET]: () => ({
      ...state,
      'itemBudget': [],
      'loading': false,
    }),
  })(state, action);
};
